<template>
  <div>
    Hi! :D
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
};
</script>
